import { render, staticRenderFns } from "./AddDocumentDetail.vue?vue&type=template&id=c263c624&"
import script from "./AddDocumentDetail.vue?vue&type=script&lang=ts&"
export * from "./AddDocumentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports